import { join } from 'lodash';

export const getJsonataExpressionForVariable = (variable: string) =>
  join(['/${ expressions.', variable, '.jsonata }'], '');

export const extractColorVarFromString = (colorString: string): string | null => {
  const pattern = /var\(--.*?-(.*?)\)/;
  const match = colorString.match(pattern);
  return match ? match[1] : null;
};
